import React, { useState, useCallback, useRef } from "react";
import { StaffFrame, AdminView, Toast } from "./DashboardShared";

export default function AdminPage() {
  const [toast, setToast] = useState(null);
  const toastTimer = useRef(null);
  const showToast = useCallback((msg, type = "error") => {
    if (toastTimer.current) clearTimeout(toastTimer.current);
    setToast({ msg, type });
    toastTimer.current = setTimeout(() => setToast(null), 3500);
  }, []);

  return (
    <StaffFrame>
      <Toast toast={toast} />
      <div className="topbar">
        <div>
          <div className="topbar-title">Vue d'ensemble</div>
          <div className="topbar-sub">Tableau de bord complet SETRAG</div>
        </div>
      </div>
      <AdminView activePage="overview" showToast={showToast} />
    </StaffFrame>
  );
}
